import { http } from '../http'
import { URL } from './_constant'

/**
 * 集体土地项目-动员大会-列表
 */
export function API_KICKOFF_MEETING_LIST(data?: BasicPageReq) {
  return http.post<ApiKickoffMeeting.ListRes>(URL.LIST, data)
}

/**
 * 集体土地项目-动员大会-全部
 */
export function API_KICKOFF_MEETING_ALL(data?: BasicPageReq) {
  return http.post<ApiKickoffMeeting.Item[]>(URL.LIST, data)
}

/**
 * 集体土地项目-动员大会-详情
 */
export function API_KICKOFF_MEETING_DETAIL(id: string) {
  return http.post<ApiKickoffMeeting.Item>(URL.DETAIL, { id })
}

/**
 * 集体土地项目-动员大会-新增
 */
export function API_KICKOFF_MEETING_ADD(data: ApiKickoffMeeting.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 集体土地项目-动员大会-删除
 */
export function API_KICKOFF_MEETING_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  集体土地项目-动员大会-编辑
 */
export function API_KICKOFF_MEETING_EDIT(data: BasicUpdateOneReq<ApiKickoffMeeting.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  集体土地项目-动员大会-禁用
 */
export function API_KICKOFF_MEETING_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 集体土地项目-动员大会-启用
 */
export function API_KICKOFF_MEETING_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 集体土地项目-动员大会-排序
 */
export function API_KICKOFF_MEETING_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}
